var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "wscn-http404-container" }, [
    _c("div", [
      _c("img", {
        staticClass: "pic-403__parent",
        attrs: { src: require("@/assets/404_images/404s.png"), alt: "403" },
      }),
      _c("img", {
        staticClass: "pic-403__text",
        attrs: { src: require("@/assets/404_images/404_text.png"), alt: "403" },
      }),
      _vm._m(0),
      _c("div", { staticClass: "goBack" }, [
        _c("span", [_vm._v("您可以看看：")]),
        _c(
          "span",
          {
            on: {
              click: function ($event) {
                return _vm.$router.push("/")
              },
            },
          },
          [_vm._v("控制台首页   |")]
        ),
        _c("span", [_vm._v("   " + _vm._s(_vm.second) + "s后返回")]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h1", { staticClass: "pic-403__h1" }, [
      _vm._v("雾霾太大，连页面都"),
      _c("b", [_vm._v("看不见了")]),
      _vm._v("？！"),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }